module.exports = __webpack_public_path__ + "static/img/8.25d4bd6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/eng/8.png
// module id = korS
// module chunks = 0